export enum SelfbillStatus {
    Unknown = 0,
    New = 1,
    Sent = 2,
    Finished = 3,
    Portal = 4,
    Rejected = 5,
    Approved = 6
}
